import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Fragment } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import AddressFormModal from '../../../components/AddressForm/AddressFormModal';
import Button from '../../../components/Button';
import CircledIcon from '../../../components/CircledIcon';
import PreferedCard from '../../../components/PreferedCard';
import useModal from '../../../hooks/useModal';
import {
  formatAddressInTwoLines,
  formatAddressToString,
} from '../../../services/addresses';
import DeleteModal from '../../widgets/deleteModal/DeleteModal';

const AddressTabContent = ({
  workAddress,
  setWorkAddress,
  alternateAddress,
  setAlternateAddress,
  homeAddress,
  setHomeAddress,
  isHomeAddressChecked,
  setIsHomeAddressChecked,
  isWorkAddressChecked,
  setIsWorkAddressChecked,
  isAlternateAddressChecked,
  setIsAlternateAddressChecked,
}: any) => {
  const [
    showDeleteWorkAdressModal,
    handleDeleteWorkAdressShow,
    handleDeleteWorkAdressClose,
  ] = useModal();

  const [
    showDeleteAlternateAdressModal,
    handleDeleteAlternateAdressShow,
    handleDeleteAlternateAdressClose,
  ] = useModal();

  const [
    showDeleteHomeAdressModal,
    handleDeleteHomeAdressShow,
    handleDeleteHomeAdressClose,
  ] = useModal();

  const [
    showAddNewAddressModal,
    handleAddNewAddressShow,
    handleAddNewAddressClose,
  ] = useModal();

  const [
    showEditWorkAddressModal,
    handleEditWorkAddressShow,
    handleEditWorkAddressClose,
  ] = useModal();

  const [
    showEditAlternateAddressModal,
    handleEditAlternateAddressShow,
    handleEditAlternateAddressClose,
  ] = useModal();

  const [
    showEditHomeAddressModal,
    handleEditHomeAddressShow,
    handleEditHomeAddressClose,
  ] = useModal();

  const handleSubmitAddress = (formData: any) => {
    if (formData.type === 'work') {
      setWorkAddress(formData);
    }
    if (formData.type === 'home') {
      setHomeAddress(formData);
    }
    if (formData.type === 'alt') {
      setAlternateAddress(formData);
    }
    handleAddNewAddressClose();
    handleEditWorkAddressClose();
    handleEditAlternateAddressClose();
    handleEditHomeAddressClose();
  };

  const handleHomeAddressChecked = () => {
    setIsHomeAddressChecked(!isHomeAddressChecked);
    setIsWorkAddressChecked(false);
    setIsAlternateAddressChecked(false);
  };

  const handleWorkAddressChecked = () => {
    setIsWorkAddressChecked(!isWorkAddressChecked);
    setIsHomeAddressChecked(false);
    setIsAlternateAddressChecked(false);
  };

  const handleAlternateAddressChecked = () => {
    setIsAlternateAddressChecked(!isAlternateAddressChecked);
    setIsHomeAddressChecked(false);
    setIsWorkAddressChecked(false);
  };

  return (
    <Fragment>
      <section className={'w-100 d-flex justify-content-between mt-7'}>
        <div className={'d-flex align-items-center'}>
          <CircledIcon
            variant={'icon-emphasized'}
            icon={light('map-location-dot')}
          />
          <h4 className={'ms-7 mb-0 text-sm-20-lg-32'}>My Addresses</h4>
        </div>
        <div className={'d-none d-lg-block'}>
          <Button
            size={'sm'}
            rightIcon={light('circle-plus')}
            onMouseDown={handleAddNewAddressShow}
          >
            Add new
          </Button>
          <AddressFormModal
            showModal={showAddNewAddressModal}
            handleClose={handleAddNewAddressClose}
            handleSubmit={handleSubmitAddress}
          />
        </div>
      </section>
      <Row className={'mt-5'}>
        <Col lg={4} className={'mt-7'}>
          <PreferedCard
            id="pc-1"
            title={'Work'}
            editButtonName={'Edit address'}
            onDelete={handleDeleteWorkAdressShow}
            onEdit={handleEditWorkAddressShow}
            onChange={handleWorkAddressChecked}
            switchName={'address-checkbox'}
            checked={isWorkAddressChecked}
          >
            {
              <div
                className={'fw-light text-fs-6 single-col d-flex flex-column'}
              >
                {formatAddressInTwoLines(workAddress).map((line, index) => (
                  <span key={index}>{line}</span>
                ))}
              </div>
            }
          </PreferedCard>
          <AddressFormModal
            showModal={showEditWorkAddressModal}
            handleClose={handleEditWorkAddressClose}
            handleSubmit={handleSubmitAddress}
            existingAddress={workAddress}
          />
          <DeleteModal
            showModal={showDeleteWorkAdressModal}
            handleClose={handleDeleteWorkAdressClose}
            handleSubmit={handleDeleteWorkAdressClose}
            title="Delete Address"
          >
            <Container>
              <Row className="text-fs-6">
                Are you sure you want to delete this address?
              </Row>
              <Row>
                <Col className="p-0 pt-4 col-12 col-lg-6">
                  <PreferedCard
                    className="border-light-gray"
                    id="pc-1"
                    title={'Work'}
                    isSwitch={false}
                    isDismissable={false}
                  >
                    {
                      <div className={'fw-light text-fs-6'}>
                        {formatAddressToString(workAddress)}
                      </div>
                    }
                  </PreferedCard>
                </Col>
              </Row>
            </Container>
          </DeleteModal>
        </Col>
        <Col lg={4} className={'mt-7'}>
          <PreferedCard
            id="pc-2"
            title={'Alternate'}
            editButtonName={'Edit address'}
            onDelete={handleDeleteAlternateAdressShow}
            onEdit={handleEditAlternateAddressShow}
            onChange={handleAlternateAddressChecked}
            switchName={'address-checkbox'}
            checked={isAlternateAddressChecked}
          >
            {
              <div
                className={'fw-light text-fs-6 single-col d-flex flex-column'}
              >
                {formatAddressInTwoLines(alternateAddress).map(
                  (line, index) => (
                    <span key={index}>{line}</span>
                  )
                )}
              </div>
            }
          </PreferedCard>
          <AddressFormModal
            showModal={showEditAlternateAddressModal}
            handleClose={handleEditAlternateAddressClose}
            handleSubmit={handleSubmitAddress}
            existingAddress={alternateAddress}
          />
          <DeleteModal
            showModal={showDeleteAlternateAdressModal}
            handleClose={handleDeleteAlternateAdressClose}
            handleSubmit={handleDeleteAlternateAdressClose}
            title="Delete Address"
          >
            <Container>
              <Row className="text-fs-6">
                Are you sure you want to delete this address?
              </Row>
              <Row>
                <Col className="p-0 pt-4 col-12 col-lg-6">
                  <PreferedCard
                    className="border-light-gray"
                    id="pc-1"
                    title={'Alternate'}
                    isSwitch={false}
                    isDismissable={false}
                  >
                    {
                      <div className={'fw-light text-fs-6'}>
                        {formatAddressToString(alternateAddress)}
                      </div>
                    }
                  </PreferedCard>
                </Col>
              </Row>
            </Container>
          </DeleteModal>
        </Col>
        <Col lg={4} className={'mt-7'}>
          <PreferedCard
            id="pc-3"
            title={'Home'}
            editButtonName={'Edit address'}
            onDelete={handleDeleteHomeAdressShow}
            onEdit={handleEditHomeAddressShow}
            onChange={handleHomeAddressChecked}
            switchName={'address-checkbox'}
            checked={isHomeAddressChecked}
          >
            {
              <div
                className={'fw-light text-fs-6 single-col d-flex flex-column'}
              >
                {formatAddressInTwoLines(homeAddress).map((line, index) => (
                  <span key={index}>{line}</span>
                ))}
              </div>
            }
          </PreferedCard>
          <AddressFormModal
            showModal={showEditHomeAddressModal}
            handleClose={handleEditHomeAddressClose}
            handleSubmit={handleSubmitAddress}
            existingAddress={homeAddress}
          />
          <DeleteModal
            showModal={showDeleteHomeAdressModal}
            handleClose={handleDeleteHomeAdressClose}
            handleSubmit={handleDeleteHomeAdressClose}
            title="Delete Address"
          >
            <Container>
              <Row className="text-fs-6">
                Are you sure you want to delete this address?
              </Row>
              <Row>
                <Col className="p-0 pt-4 col-12 col-lg-6">
                  <PreferedCard
                    className="border-light-gray"
                    id="pc-3"
                    title={'Home'}
                    isSwitch={false}
                    isDismissable={false}
                  >
                    {
                      <div className={'fw-light text-fs-6'}>
                        {formatAddressToString(homeAddress)}
                      </div>
                    }
                  </PreferedCard>
                </Col>
              </Row>
            </Container>
          </DeleteModal>
        </Col>
      </Row>
      <div className={'w-100 mt-7 d-flex flex-column d-lg-none'}>
        <Button
          variant={'primary-outline'}
          onMouseDown={handleAddNewAddressShow}
          rightIcon={light('circle-plus')}
        >
          Add new
        </Button>
      </div>
    </Fragment>
  );
};

export default AddressTabContent;
